import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityReport } from "../../entity/EntityReport";
import { EntityReportDet } from "../../entity/EntityReportDet";

export class DtoReportsPostReq extends EntityReport {

  //詳細用
  //-----------------------
  public details: EntityReportDet[] = [];
  
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
